function getSensor() {
    if (typeof window === 'undefined') {
        return null;
    }
    const path = window.location.host === 'www.zillow.com' ? '/HYx10rg3/init.js' : '/f7jE4FXv/init.js';
    return `
        (function(){
            // Custom parameters
            // window._pxParam1 = "<param1>";
            var p = document.getElementsByTagName('script')[0],
                s = document.createElement('script');
            s.async = 1;
            s.src = '${path}';
            p.parentNode.insertBefore(s,p);
        }());
    `;
}

export default getSensor;
